// extracted by mini-css-extract-plugin
export default {"section":"mBqPf","galleryItem":"djZLN","tabs":"TOUQf","arrows":"C9UGW","visible":"e60d_","text":"k9Ild DS0GQ","wrapperGallery":"BSBk8 ZdH1P","wrapperProgress":"p8YtA ZdH1P"};